import React, { useContext } from "react";
// React Bootstrap
import { Button } from "react-bootstrap";
// Componentes
import VistaCiviles from "../vistas/VistaCiviles";
import FormCiviles from "../formularios/FormCiviles";
// Contexto
import { ModalContext } from "../../../context/modalContext";

const Civiles = ({ datosComunidad, handlePutDatosComunidad, permisoEdicion}) => {
  // Contexto
  const { modalSetShow, modalSetTitle, modalSetContent } = useContext(ModalContext);

  return (
    <React.Fragment>
      <VistaCiviles datosComunidad={datosComunidad} />
      {permisoEdicion && <Button
        variant="outline-primary"
        size="sm"
        className="float-right mr-4"
        onClick={() => {
          modalSetShow(true, "80%");
          modalSetTitle(`Editar datos civiles`);
          modalSetContent(<FormCiviles defaultValues={datosComunidad} submissionHandler={handlePutDatosComunidad} />);
        }}
      >
        Editar
      </Button>}
    </React.Fragment>
  );
};

export default Civiles;
